// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__hHwG5","fixed":"Header_fixed__1R-_i","box":"Header_box__2sWSM","h1":"Header_h1__2w3sl"};